import React from 'react';
import { useNaphthaleneStore } from '../store/useNaphthaleneStore';
import { useThemeStore } from '../../titration/store/themeStore';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export function NaphthaleneChart() {
  const { recordedData } = useNaphthaleneStore();
  const isDark = useThemeStore(s => s.resolvedTheme === 'dark');

  const textColor = isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)';
  const gridColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

  const data = {
    labels: recordedData.map(d => d.time.toFixed(0)),
    datasets: [
      {
        label: 'Temperature (°C)',
        data: recordedData.map(d => d.temp),
        borderColor: 'rgb(249, 115, 22)', // Orange 500
        backgroundColor: 'rgba(249, 115, 22, 0.5)',
        tension: 0.1,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          color: textColor,
          font: { family: 'ui-sans-serif, system-ui' }
        }
      },
      title: {
        display: true,
        text: 'Naphthalene Heating/Cooling Curve',
        color: textColor,
        font: { size: 16, weight: 'normal' as const }
      },
      tooltip: {
        backgroundColor: isDark ? 'rgba(15, 23, 42, 0.9)' : 'rgba(255, 255, 255, 0.9)',
        titleColor: isDark ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.9)',
        bodyColor: isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)',
        borderColor: isDark ? 'rgba(51, 65, 85, 0.5)' : 'rgba(203, 213, 225, 0.5)',
        borderWidth: 1,
      }
    },
    scales: {
      y: {
        beginAtZero: false,
        min: 20,
        max: 100,
        grid: { color: gridColor },
        ticks: { color: textColor },
        title: {
          display: true,
          text: 'Temperature (°C)',
          color: textColor
        }
      },
      x: {
        grid: { color: gridColor },
        ticks: { color: textColor },
        title: {
          display: true,
          text: 'Time (s)',
          color: textColor
        }
      }
    },
    animation: {
      duration: 300,
    }
  };

  return (
    <div className="bg-card/90 border border-border/50 rounded-xl overflow-hidden backdrop-blur-md p-4 h-full flex flex-col">
      <div className="flex-1 w-full min-h-[300px]">
        <Line options={options} data={data} />
      </div>
    </div>
  );
}
